import request from '@/utils/request'
import { datePartFromLastUpdate } from '@/composables/useRelativeTime'

const SUPPRESS_KEY = 'risk_banner_suppressed'
const SUPPRESS_DAY_KEY = 'risk_banner_suppressed_day'

function isSuppressed() {
  try {
    return sessionStorage.getItem(SUPPRESS_KEY) === '1'
  } catch (_) {
    return false
  }
}

function suppressForToday(day) {
  try {
    sessionStorage.setItem(SUPPRESS_KEY, '1')
    if (day) sessionStorage.setItem(SUPPRESS_DAY_KEY, day)
  } catch (_) {
    // ignore: sessionStorage may be unavailable (privacy mode / disabled)
  }
}

function clearSuppress() {
  try {
    sessionStorage.removeItem(SUPPRESS_KEY)
    sessionStorage.removeItem(SUPPRESS_DAY_KEY)
  } catch (_) {
    // ignore: sessionStorage may be unavailable (privacy mode / disabled)
  }
}

function suppressedDay() {
  try {
    return sessionStorage.getItem(SUPPRESS_DAY_KEY) || ''
  } catch (_) {
    return ''
  }
}

export default {
  namespaced: true,
  state: () => ({
    summary: {
      highRiskCount: 0,
      totalIssueCount: 0,
      lastUpdate: '',
    },
    items: [],
    loading: false,
    heartbeatTimer: null,
  }),
  getters: {
    highRiskCount: (s) => Number(s.summary?.highRiskCount || 0),
    lastUpdate: (s) => String(s.summary?.lastUpdate || ''),
    shouldShowBanner: (s, g) => {
      return g.highRiskCount > 0 && !isSuppressed()
    },
  },
  mutations: {
    SET_LOADING(state, v) {
      state.loading = !!v
    },
    SET_DATA(state, payload) {
      const sum = payload?.summary || {}
      state.summary = {
        highRiskCount: Number(sum.highRiskCount || 0),
        totalIssueCount: Number(sum.totalIssueCount || 0),
        lastUpdate: String(sum.lastUpdate || ''),
      }
      state.items = Array.isArray(payload?.items) ? payload.items : []
    },
    SET_HEARTBEAT_TIMER(state, timer) {
      state.heartbeatTimer = timer
    },
  },
  actions: {
    suppressBanner({ state }) {
      suppressForToday(datePartFromLastUpdate(state.summary?.lastUpdate))
    },
    clearSuppress() {
      clearSuppress()
    },
    async refreshBlacklist({ commit, state, getters }) {
      commit('SET_LOADING', true)
      try {
        const resp = await request.get('/api/v1/fitment/blacklist', { silent: true })
        const data = resp?.data || resp || {}
        commit('SET_DATA', data)

        // 复活协议 A：风险清零，立刻清除屏蔽，准备迎接下一次风险
        if (getters.highRiskCount === 0) {
          clearSuppress()
        } else {
          // 复活协议 B：跨天清理“稍后处理”的会话记忆
          const day = datePartFromLastUpdate(state.summary?.lastUpdate)
          const sDay = suppressedDay()
          if (sDay && day && sDay !== day) {
            clearSuppress()
          }
        }
        return data
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async startHeartbeat({ state, commit, dispatch }) {
      if (state.heartbeatTimer) return
      await dispatch('refreshBlacklist')
      const timer = setInterval(() => {
        dispatch('refreshBlacklist').catch(() => {})
      }, 10 * 60 * 1000)
      commit('SET_HEARTBEAT_TIMER', timer)
    },
    stopHeartbeat({ state, commit }) {
      if (state.heartbeatTimer) {
        clearInterval(state.heartbeatTimer)
      }
      commit('SET_HEARTBEAT_TIMER', null)
    },
  },
}

